import { render, staticRenderFns } from "./animal.vue?vue&type=template&id=318b932c&scoped=true"
import script from "./animal.vue?vue&type=script&lang=js"
export * from "./animal.vue?vue&type=script&lang=js"
import style0 from "./animal.vue?vue&type=style&index=0&id=318b932c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b932c",
  null
  
)

export default component.exports